import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.models';
import { USER_FEATURE_KEY } from './user.reducer';

export const userFeatureSelector = createFeatureSelector<UserState>(USER_FEATURE_KEY);
// eslint-disable-next-line
export const getUserIdState = () => createSelector(userFeatureSelector, (state: UserState) => state.userId);
